export const BANNER_WIDTH = {
  SIZE_100: '--banner-width-size-100', // homepage
  SIZE_94: '--banner-width-size-94', // movies
  SIZE_66: '--banner-width-size-66', // TV Series
} as const
export type BANNER_WIDTH = (typeof BANNER_WIDTH)[keyof typeof BANNER_WIDTH]
